"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_case__study__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebebeb;}.cls-2{fill:#f4f4f4;}.cls-2,.cls-8{opacity:0.06;}.cls-2,.cls-3{isolation:isolate;}.cls-3{opacity:0.2;fill:url(#linear-gradient);}.cls-4{fill:none;}.cls-5{fill:#fff;}.cls-6{fill:#4a4d4e;}.cls-7{fill:#e90000;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 108.9,
    y1: 126.71,
    x2: 177.82,
    y2: 57.78,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 192.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "case-study-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "ed616829-057a-48dc-bbe5-4161d821ad2c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cf39fcdc-8112-4c76-a819-d6cd7fcb2128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e0bef6bb-3170-49a2-8630-506e3a19df43"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c4e1a9f2-3504-492e-a2fc-78114e3bd5a5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d1a10362-c31b-4ac3-b4e6-39cfa30057d8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c9cc2080-47e9-419d-b9b4-4ecef76e9c91"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e087c2dd-777b-4bcd-be96-2b2bacec4607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f5f158f4-a4b2-444e-b592-41b28efe3395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f12a75af-17f2-4aac-b0f6-1e8d8f0d38d3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a84d5521-e1f3-4e8f-8c74-b20bbbba497a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.5,
    y: 16,
    width: 104.5,
    height: 144,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 55.5,
    y: 16,
    width: 104.5,
    height: 144,
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M148,160h-7.77l-.1-125L160,55.08V148A12,12,0,0,1,148,160Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 40,
    y: 32,
    width: 104.25,
    height: 144,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 58.5,
    y: 107,
    width: 64,
    height: 4,
    rx: 1.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 58.5,
    y: 91,
    width: 64,
    height: 4,
    rx: 1.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 58.5,
    y: 75,
    width: 64,
    height: 4,
    rx: 1.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 58.5,
    y: 123,
    width: 64,
    height: 4,
    rx: 1.41
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148,158h-3.75v2H148a12,12,0,0,0,12-12v-2A12,12,0,0,1,148,158Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.25,174H52a12,12,0,0,1-12-12v2a12,12,0,0,0,12,12h80.25a12,12,0,0,0,12-12v-2A12,12,0,0,1,132.25,174Z",
    transform: "translate(0 0)"
  })))))))))))));
}

var _default = ic_case__study__dark;
exports.default = _default;